<template>
    <section id="Reset-password">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="Reset-password mx-auto mt-5">
                        <div class="Reset-password-wrap">
                            <div class="Reset-password-form mx-auto">
                                <div class="col-xs-12">
                                    <div class="reset-text text-center">
                                        <p class="p4b">Reset Password</p>
                                        <p class="p1n ">Forgot your password? Just set a new one here. </p>
                                        <p v-if="!match" class="c5 mb-0 p1n">Password do not match</p>
                                    </div>
                                </div>
                                <div class="col-xs-12">
                                    <div class="form-div mt-3">
                                        <form action="">
                                            <EmailInput 
                                                :on-submit="ResetPassword"
                                                :activ-fields="{password: true, confirmPass: true}"
                                                :on-pass-confirmed="onPassConfirmed"
                                                :on-confirm-pass="onConfirmPass"/>
                                            <button
                                                    @click="ResetPassword"
                                                    type="button"
                                                    class="d-block w-100 p2b log-in mt-5">
                                                Save
                                            </button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import { message } from 'ant-design-vue'
    import EmailInput from '@/components/EmailPasswordValid/EmailInput.vue'
    import {auth} from "../firebase";

    export default {
        name: 'ResetPassword',
        components: {
            EmailInput
        },
        data() {
            return {
                email: '',
                newpassword: '',
                confirmpassword: '',
                match: true
            }
        },
        methods: {
            ResetPassword() {
                if (this.newpassword !== this.confirmpassword) {
                    this.match = false
                    return
                }

                auth.confirmPasswordReset(
                    this.$route.query.oobCode,
                    this.confirmpassword
                )
                .then(resp => {
                    message.success('Password reset successful!')
                    this.$router.push('/').catch(() => {})
                }).catch(e => this.$store.dispatch('handleErrors', e))
            },
            onPassConfirmed(val) {
                this.newpassword = val;
            },
            onConfirmPass(val) {
                this.confirmpassword = val;
            }

        }
    }

</script>

<style scoped lang="scss">
    div.Reset-password {
        width: 450px;
        height: 574px;

        div.Reset-password-wrap {
            width: 450px;
            height: 500px;
            background: #FFFFFF;
            -webkit-box-shadow: 0px 18px 23px rgba(0, 0, 0, 0.05);
            box-shadow: 0px 18px 23px rgba(0, 0, 0, 0.05);
            border-radius: 5px;

            div.Reset-password-form {
                width: 325px;
                padding-top: 52px;
            }
            div.form-div {
                form {
                    .md-field {
                        width: 100%;
                        min-height: 48px;
                        margin: 0px 0 50px;
                        padding-top: 8px;
                        display: flex;
                        position: relative;
                        font-family: inherit;
                        &:first-child {
                            margin-top: 59px;
                        }
                        &.md-theme-default {
                            &::after, &::before {
                                background-color: transparent;
                                content: none !important;
                            }
                            .md-checkbox {
                                width: auto;
                                margin: 0px 0px 20px 0;
                                float: left;

                                .md-checkbox-container {
                                    background: #B8CDD7;
                                    border: 1px solid #8DA0A9;
                                    box-shadow: inset 0px 10px 40px rgba(0, 0, 0, 0.05);

                                    input {
                                        position: absolute;
                                        left: 0 !important;
                                        right: 0 !important;
                                        top: 0 !important;
                                        bottom: 0 !important;
                                        margin: auto !important;
                                    }
                                }
                                .md-checkbox-label {
                                    height: 20px;
                                    padding-left: 7px;
                                    position: relative;
                                    line-height: 20px;
                                }

                            }
                        }
                        &.md-focused label, &.md-has-value label {
                            pointer-events: auto;
                            top: 5px;
                            opacity: 1;
                            font-size: 12px;
                            background: #fff;
                        }
                        .md-input {
                            height: 48px !important;
                            border: 1px solid #C7C4C4 !important;
                            box-sizing: border-box;
                            border-radius: 5px;
                            padding-left: 10px !important;
                        }
                        label {
                            position: absolute;
                            top: 50%;
                            left: 11px;
                            pointer-events: none;
                            transform: translateY(-35%);
                            transition: .4s cubic-bezier(.25, .8, .25, 1);
                            transition-duration: .3s;
                            font-size: 13px;
                            line-height: 20px;
                            margin: 0;
                        }
                    }
                    button.log-in {
                        height: 48px;
                        color: #ffffff;
                        background: #727CF5;
                        border-radius: 5px;
                        border: 0;
                        transition: all 0.1s linear;
                        &:hover {
                            box-shadow: 0px 4px 8px rgba(114, 124, 245, 0.45);

                        }
                    }
                }
            }
        }
    }
    @media only screen and (min-width: 280px) and (max-width: 450px) {
        div.Reset-password,
        .Reset-password-wrap {
            width: 100%;
        }

        div.Reset-password-form {
            width: 280px;
        }

        .md-checkbox[data-v-60214417] {
            transform: translate(-10%);
        }
    }

</style>
